import type { NotificationDeliveryStatus } from '@repo/api-contracts';
import type { StatusTone } from '@/shared/ui';

/**
 * 알림 발송 결과 배지(StatusBadge) 톤 — 대기는 neutral, 성공은 positive, 실패는 다시 보내야 할 건이라 danger, 건너뜀은
 * 운영자가 사유(꺼진 알림·상태 변경 등)를 확인할 건이라 attention. 표시 이름은 계약 NOTIFICATION_DELIVERY_STATUS_LABELS 다.
 */
export const NOTIFICATION_STATUS_TONES: Readonly<Record<NotificationDeliveryStatus, StatusTone>> = {
  QUEUED: 'neutral',
  SENT: 'positive',
  FAILED: 'danger',
  SKIPPED: 'attention',
};
